import { Review } from "src/config/reviewsPerProduct";
import ReviewsList from "./ReviewsList";
import { useTranslations } from "next-intl";

interface ReviewsSectionProps {
  productReviews: Review[];
  productHandle: string;
}

const ReviewsSection = ({
  productReviews,
  productHandle,
}: ReviewsSectionProps) => {
  const t = useTranslations("ProductOverview");
  return (
    <section className="flex flex-col items-center gap-2.5">
      <h2 className="text-2xl font-bold lg:text-3xl">{t("reviews")}</h2>
      <p>{t("reason_millions_of_women_switched")}</p>
      <ReviewsList reviews={productReviews} productHandle={productHandle} />
    </section>
  );
};

export default ReviewsSection;
